export const LinkedInURL = "https://www.linkedin.com/company/linx-systems";
